import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { BETA_TINY_MCE_VERSION, TINY_MCE_VERSION } from '../constants';

export const useTinyMceVersion = () => {
  const { WYSIWYGEditorV7Upgrade } = useSelector(selectFeatureFlags);
  const version = WYSIWYGEditorV7Upgrade ? BETA_TINY_MCE_VERSION : TINY_MCE_VERSION;

  return version;
};
